import { render, staticRenderFns } from "./layout-image-default.vue?vue&type=template&id=4316a134&scoped=true&"
import script from "./layout-image-default.vue?vue&type=script&lang=js&"
export * from "./layout-image-default.vue?vue&type=script&lang=js&"
import style0 from "./layout-image-default.vue?vue&type=style&index=0&id=4316a134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4316a134",
  null
  
)

export default component.exports